(function ($) {
    var form = document.querySelector('.wpcf7-form');

    /*
     *       Toggle form invalid class to inputs parent container for styling
     */

    if (form) {
        form.addEventListener( 'wpcf7submit', function( event ) {
            var formInputs = $('.wpcf7-form').find('.wpcf7-form-control');
            var invalidClass = 'cf7-invalid';

            setTimeout(function(){

                formInputs.each(function(){
                    if ($(this).hasClass('wpcf7-not-valid')) {
                        $(this).parent().parent().addClass(invalidClass);
                    } else {
                        $(this).parent().parent().removeClass(invalidClass);
                    }
                });
            }, 200);
        });
    }


    /*
    *       Scroll to first invalid field on Contact Form 7 validation error event
     */

    document.addEventListener( 'wpcf7invalid', function( event ) {
        setTimeout( function() {
            $('html').stop().animate({
                scrollTop: $('#' + event.detail.unitTag + ' .wpcf7-not-valid').eq(0).offset().top - 140,
            }, 500, 'swing');
        }, 100);
    }, false );

})(jQuery);